// src/services/leaveService.js
// Wraps /api/leaves/* backend calls.
// Bug 05 fix: createLeaveRequest function add ki — pehle missing thi.

import { api } from './api';

export const leaveService = {
  // HR / Admin: sari leaves dekho
  getAllLeaves: (status, leaveType) => {
    const params = new URLSearchParams();
    if (status) params.append('status_filter', status);
    if (leaveType) params.append('leave_type', leaveType);
    const qs = params.toString();
    return api.get('/api/leaves/' + (qs ? '?' + qs : ''));
  },

  // Ek specific employee ki leaves
  getEmployeeLeaves: (employeeId) =>
    api.get('/api/leaves/employee/' + employeeId),

  // Employee ki leave balance
  getLeaveBalance: (employeeId, year) =>
    api.get('/api/leaves/balance/' + employeeId + (year ? '?year=' + year : '')),

  // Employee ke apne requests
  getMyLeaves: () =>
    api.get('/api/leaves/my-requests'),

  // Bug 05 fix: ye function missing thi — employee nayi leave request submit karta hai
  createLeaveRequest: (data) =>
    api.post('/api/leaves/', data),

  // HR: leave approve ya reject karo
  updateLeave: (leaveId, status, adminComment) =>
    api.put('/api/leaves/' + leaveId + '/status', { status, admin_comment: adminComment || null }),

  // Employee: apni pending leave cancel karo
  cancelLeave: (leaveId, employeeId) =>
    api.post('/api/leaves/' + leaveId + '/cancel?employee_id=' + encodeURIComponent(employeeId)),

  // HR/Admin: dynamic leave policy configuration (global / department / employee)
  getLeavePolicies: () =>
    api.get('/api/leaves/policies'),

  saveLeavePolicy: (data) =>
    api.post('/api/leaves/policies', data),

  deleteLeavePolicy: (policyId) =>
    api.delete('/api/leaves/policies/' + policyId),
};